exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".credential__2dURG{color:#7c7c7c;padding:5px;text-align:center;font-size:12px}.credential__2dURG a{text-decoration:none;font-weight:700;font-size:12px;color:#7c7c7c}", "", {"version":3,"sources":["/usr/src/app/src/components/Credential/Credential.scss"],"names":[],"mappings":"AAAA,mBACI,cACA,YACA,kBACA,cAAe,CAJnB,qBAOQ,qBACA,gBACA,eACA,aAAc,CACjB","file":"Credential.scss","sourcesContent":[".credential {\n    color: #7c7c7c;\n    padding: 5px;\n    text-align: center;\n    font-size: 12px;\n\n    a {\n        text-decoration: none;\n        font-weight: bold;\n        font-size: 12px;\n        color: #7c7c7c;\n    }\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"credential": "credential__2dURG"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader??ref--4-2!../node_modules/postcss-loader/lib??postcss!../node_modules/preact-cli/lib/lib/webpack/proxy-loader.js??ref--2-0!./components/Credential/Credential.scss
// module id = MMYI
// module chunks = 0